import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=5fb29dca&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=js&"
export * from "./Accessibility.vue?vue&type=script&lang=js&"
import style0 from "./Accessibility.vue?vue&type=style&index=0&id=5fb29dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb29dca",
  null
  
)

export default component.exports